import { convertFromBoolean, convertToBoolean, Form, FormDropDown, FormInput, FormRadio } from 'metrix-common3';
import { FormattedMessage } from 'react-intl';

const ProfileSupernovaCommercialInsuranceHistory = ({
    pageCode,
    doUpsertPolicy,
    doGetPolicy,
    allowEdit,
    policy,
    doReducePolicyElement,
    reference,
    validationInfo,
    tooltipInfo,
    doUpsertTooltipInfo,
    doReduceTooltipInfoElement,
}) => (
    <>
        <Form
            pageCode={pageCode}
            sectionCode='insuranceHistory'
            header={<FormattedMessage id='Profile_SupernovaCommercial_InsuranceHistory.insuranceHistory' />}
            tooltipInfo={tooltipInfo}
            validationInfo={validationInfo}
            saveTooltipInfo={() => doUpsertTooltipInfo(policy.product)}
            reduceTooltipInfoElement={doReduceTooltipInfoElement}
            saveEvent={doUpsertPolicy}
            cancelEvent={doGetPolicy}
            allowEdit={allowEdit}
        >
            <FormRadio
                fieldCode='snCommercialInsuranceHistory.hasClaims'
                label={<FormattedMessage id='Profile_SupernovaCommercial_InsuranceHistory.pastInsuranceClaims' />}
                value={
                    policy.snCommercialInsuranceHistory?.hasClaims !== undefined && {
                        code: convertFromBoolean(policy.snCommercialInsuranceHistory.hasClaims),
                    }
                }
                references={reference?.references.YesNo}
                referencesEvent={() => reference.doGetReferences('YesNo')}
                changeEvent={(value) =>
                    doReducePolicyElement({
                        code: 'snCommercialInsuranceHistory.hasClaims',
                        value: convertToBoolean(value.code),
                    })
                }
                allowEdit
            />
            <FormRadio
                fieldCode='snCommercialInsuranceHistory.hasDeniedInsurance'
                label={<FormattedMessage id='Profile_SupernovaCommercial_InsuranceHistory.deniedInsurance' />}
                value={
                    policy.snCommercialInsuranceHistory?.hasDeniedInsurance !== undefined && {
                        code: convertFromBoolean(policy.snCommercialInsuranceHistory.hasDeniedInsurance),
                    }
                }
                references={reference?.references.YesNo}
                referencesEvent={() => reference.doGetReferences('YesNo')}
                changeEvent={(value) =>
                    doReducePolicyElement({
                        code: 'snCommercialInsuranceHistory.hasDeniedInsurance',
                        value: convertToBoolean(value.code),
                    })
                }
                allowEdit
            />
            <FormRadio
                fieldCode='snCommercialInsuranceHistory.hasNonPaymentInsurance'
                label={<FormattedMessage id='Profile_SupernovaCommercial_InsuranceHistory.missedPayments' />}
                value={
                    policy.snCommercialInsuranceHistory?.hasNonPaymentInsurance !== undefined && {
                        code: convertFromBoolean(policy.snCommercialInsuranceHistory.hasNonPaymentInsurance),
                    }
                }
                references={reference?.references.YesNo}
                referencesEvent={() => reference.doGetReferences('YesNo')}
                changeEvent={(value) =>
                    doReducePolicyElement({
                        code: 'snCommercialInsuranceHistory.hasNonPaymentInsurance',
                        value: convertToBoolean(value.code),
                    })
                }
                allowEdit
            />
        </Form>
        {policy.snCommercialInsuranceHistory.hasClaims && (
            <Form
                pageCode={pageCode}
                sectionCode='claimsHistory'
                header={<FormattedMessage id='Profile_SupernovaCommercial_InsuranceHistory.claimsHistory' />}
                tooltipInfo={tooltipInfo}
                validationInfo={validationInfo}
                saveTooltipInfo={() => doUpsertTooltipInfo(policy.product)}
                reduceTooltipInfoElement={doReduceTooltipInfoElement}
                saveEvent={doUpsertPolicy}
                cancelEvent={doGetPolicy}
                allowEdit={allowEdit}
            >
                <FormDropDown
                    fieldCode='snCommercialInsuranceHistory.claimsInLastThreeYearsNumberCode'
                    label={
                        <FormattedMessage id='Profile_SupernovaCommercial_InsuranceHistory.claimsInLastThreeYears' />
                    }
                    value={{ code: policy.snCommercialInsuranceHistory.claimsInLastThreeYearsNumberCode }}
                    references={reference?.references['sn-commercial']?.NumberOfClaims}
                    referencesEvent={() => reference.doGetReferences('sn-commercial.NumberOfClaims')}
                    changeEvent={(value) =>
                        doReducePolicyElement({
                            code: 'snCommercialInsuranceHistory.claimsInLastThreeYearsNumberCode',
                            value: value.code,
                        })
                    }
                    allowEdit
                />
            </Form>
        )}
        {policy.snCommercialInsuranceHistory.hasClaims &&
            policy.snCommercialInsuranceHistory.claimsInLastThreeYearsNumberCode >= 1 && (
                <Form
                    pageCode={pageCode}
                    sectionCode='claimOneDetails'
                    header={<FormattedMessage id='Profile_SupernovaCommercial_InsuranceHistory.claimOneDetails' />}
                    tooltipInfo={tooltipInfo}
                    validationInfo={validationInfo}
                    saveTooltipInfo={() => doUpsertTooltipInfo(policy.product)}
                    reduceTooltipInfoElement={doReduceTooltipInfoElement}
                    saveEvent={doUpsertPolicy}
                    cancelEvent={doGetPolicy}
                    allowEdit={allowEdit}
                >
                    <FormInput
                        fieldCode='snCommercialInsuranceHistory.claimOneYear'
                        label={<FormattedMessage id='Profile_SupernovaCommercial_InsuranceHistory.claimYear' />}
                        value={policy.snCommercialInsuranceHistory.claimOneYear}
                        changeEvent={(value) =>
                            doReducePolicyElement({
                                code: 'snCommercialInsuranceHistory.claimOneYear',
                                value: value,
                            })
                        }
                        type='number'
                        allowEdit
                    />
                    <FormDropDown
                        fieldCode='snCommercialInsuranceHistory.claimOneTypeCode'
                        label={<FormattedMessage id='Profile_SupernovaCommercial_InsuranceHistory.claimType' />}
                        value={{ code: policy.snCommercialInsuranceHistory.claimOneTypeCode }}
                        references={reference?.references['sn-commercial']?.ClaimType}
                        referencesEvent={() => reference.doGetReferences('sn-commercial.ClaimType')}
                        changeEvent={(value) =>
                            doReducePolicyElement({
                                code: 'snCommercialInsuranceHistory.claimOneTypeCode',
                                value: value.code,
                            })
                        }
                        allowEdit
                    />
                    <FormInput
                        fieldCode='snCommercialInsuranceHistory.claimOnePriorInsurer'
                        label={<FormattedMessage id='Profile_SupernovaCommercial_InsuranceHistory.insuranceCompany' />}
                        value={policy.snCommercialInsuranceHistory.claimOnePriorInsurer}
                        changeEvent={(value) =>
                            doReducePolicyElement({
                                code: 'snCommercialInsuranceHistory.claimOnePriorInsurer',
                                value,
                            })
                        }
                        type='text'
                        allowEdit
                    />
                    <FormInput
                        fieldCode='snCommercialInsuranceHistory.claimOneAmount'
                        label={<FormattedMessage id='Profile_SupernovaCommercial_InsuranceHistory.claimAmount' />}
                        value={policy.snCommercialInsuranceHistory.claimOneAmount}
                        changeEvent={(value) =>
                            doReducePolicyElement({
                                code: 'snCommercialInsuranceHistory.claimOneAmount',
                                value,
                            })
                        }
                        type='currency'
                        allowEdit
                    />
                </Form>
            )}
        {policy.snCommercialInsuranceHistory.hasClaims &&
            policy.snCommercialInsuranceHistory.claimsInLastThreeYearsNumberCode >= 2 && (
                <Form
                    pageCode={pageCode}
                    sectionCode='claimTwoDetails'
                    header={<FormattedMessage id='Profile_SupernovaCommercial_InsuranceHistory.claimTwoDetails' />}
                    tooltipInfo={tooltipInfo}
                    validationInfo={validationInfo}
                    saveTooltipInfo={() => doUpsertTooltipInfo(policy.product)}
                    reduceTooltipInfoElement={doReduceTooltipInfoElement}
                    saveEvent={doUpsertPolicy}
                    cancelEvent={doGetPolicy}
                    allowEdit={allowEdit}
                >
                    <FormInput
                        fieldCode='snCommercialInsuranceHistory.claimTwoYear'
                        label={<FormattedMessage id='Profile_SupernovaCommercial_InsuranceHistory.claimYear' />}
                        value={policy.snCommercialInsuranceHistory.claimTwoYear}
                        changeEvent={(value) =>
                            doReducePolicyElement({
                                code: 'snCommercialInsuranceHistory.claimTwoYear',
                                value,
                            })
                        }
                        type='number'
                        allowEdit
                    />
                    <FormDropDown
                        fieldCode='snCommercialInsuranceHistory.claimTwoTypeCode'
                        label={<FormattedMessage id='Profile_SupernovaCommercial_InsuranceHistory.claimType' />}
                        value={{ code: policy.snCommercialInsuranceHistory.claimTwoTypeCode }}
                        references={reference?.references['sn-commercial']?.ClaimType}
                        referencesEvent={() => reference.doGetReferences('sn-commercial.ClaimType')}
                        changeEvent={(value) =>
                            doReducePolicyElement({
                                code: 'snCommercialInsuranceHistory.claimTwoTypeCode',
                                value: value.code,
                            })
                        }
                        allowEdit
                    />
                    <FormInput
                        fieldCode='snCommercialInsuranceHistory.claimTwoPriorInsurer'
                        label={<FormattedMessage id='Profile_SupernovaCommercial_InsuranceHistory.insuranceCompany' />}
                        value={policy.snCommercialInsuranceHistory.claimTwoPriorInsurer}
                        changeEvent={(value) =>
                            doReducePolicyElement({
                                code: 'snCommercialInsuranceHistory.claimTwoPriorInsurer',
                                value,
                            })
                        }
                        type='text'
                        allowEdit
                    />
                    <FormInput
                        fieldCode='snCommercialInsuranceHistory.claimTwoAmount'
                        label={<FormattedMessage id='Profile_SupernovaCommercial_InsuranceHistory.claimAmount' />}
                        value={policy.snCommercialInsuranceHistory.claimTwoAmount}
                        changeEvent={(value) =>
                            doReducePolicyElement({
                                code: 'snCommercialInsuranceHistory.claimTwoAmount',
                                value,
                            })
                        }
                        type='currency'
                        allowEdit
                    />
                </Form>
            )}
        {policy.snCommercialInsuranceHistory.hasClaims &&
            policy.snCommercialInsuranceHistory.claimsInLastThreeYearsNumberCode >= 3 && (
                <Form
                    pageCode={pageCode}
                    sectionCode='claimThreeDetails'
                    header={<FormattedMessage id='Profile_SupernovaCommercial_InsuranceHistory.claimThreeDetails' />}
                    tooltipInfo={tooltipInfo}
                    validationInfo={validationInfo}
                    saveTooltipInfo={() => doUpsertTooltipInfo(policy.product)}
                    reduceTooltipInfoElement={doReduceTooltipInfoElement}
                    saveEvent={doUpsertPolicy}
                    cancelEvent={doGetPolicy}
                    allowEdit={allowEdit}
                >
                    <FormInput
                        fieldCode='snCommercialInsuranceHistory.claimThreeYear'
                        label={<FormattedMessage id='Profile_SupernovaCommercial_InsuranceHistory.claimYear' />}
                        value={policy.snCommercialInsuranceHistory.claimThreeYear}
                        changeEvent={(value) =>
                            doReducePolicyElement({
                                code: 'snCommercialInsuranceHistory.claimThreeYear',
                                value,
                            })
                        }
                        type='number'
                        allowEdit
                    />
                    <FormDropDown
                        fieldCode='snCommercialInsuranceHistory.claimThreeTypeCode'
                        label={<FormattedMessage id='Profile_SupernovaCommercial_InsuranceHistory.claimType' />}
                        value={{ code: policy.snCommercialInsuranceHistory.claimThreeTypeCode }}
                        references={reference?.references['sn-commercial']?.ClaimType}
                        referencesEvent={() => reference.doGetReferences('sn-commercial.ClaimType')}
                        changeEvent={(value) =>
                            doReducePolicyElement({
                                code: 'snCommercialInsuranceHistory.claimThreeTypeCode',
                                value: value.code,
                            })
                        }
                        allowEdit
                    />
                    <FormInput
                        fieldCode='snCommercialInsuranceHistory.claimThreePriorInsurer'
                        label={<FormattedMessage id='Profile_SupernovaCommercial_InsuranceHistory.insuranceCompany' />}
                        value={policy.snCommercialInsuranceHistory.claimThreePriorInsurer}
                        changeEvent={(value) =>
                            doReducePolicyElement({
                                code: 'snCommercialInsuranceHistory.claimThreePriorInsurer',
                                value,
                            })
                        }
                        type='text'
                        allowEdit
                    />
                    <FormInput
                        fieldCode='snCommercialInsuranceHistory.claimThreeAmount'
                        label={<FormattedMessage id='Profile_SupernovaCommercial_InsuranceHistory.claimAmount' />}
                        value={policy.snCommercialInsuranceHistory.claimThreeAmount}
                        changeEvent={(value) =>
                            doReducePolicyElement({
                                code: 'snCommercialInsuranceHistory.claimThreeAmount',
                                value,
                            })
                        }
                        type='currency'
                        allowEdit
                    />
                </Form>
            )}
    </>
);

export default ProfileSupernovaCommercialInsuranceHistory;
